import React from "react";
import { Box, Skeleton } from "@mui/material";

type Props = {
  index: number;
};

export const LoadingLegendItem = ({ index }: Props) => {
  return (
    <Box
      key={`legend-skeleton-${index}`}
      px={1.5}
      py={2}
      minHeight={72}
      sx={{
        borderBottom: (theme) =>
          index === 4 ? "none" : `1px solid ${theme.palette.border.secondary}`,
      }}
    >
      <Box display="flex" alignItems="center" gap="6px" mb={1}>
        <Skeleton variant="circular" width={12} height={12} />
        <Skeleton variant="text" width={96} height={22} />
      </Box>
      <Box display="flex" alignItems="center" gap={1.5}>
        <Skeleton
          variant="rounded"
          width="100%"
          height={8}
          sx={{ borderRadius: "8px" }}
        />
        <Skeleton variant="text" width={56} height={22} />
      </Box>
    </Box>
  );
};
